import { FlowActionTypes } from '../store/flow/action-types';
import { isDeveloperFlow } from '../store/flow/selectors';
import { AppActionTypes } from '../store/app/action-types';
import { executeCallbackIfEmailSubmitted } from '../flow-management/checkForEmailUtils';
import { prefillCompanyDomainFromEmail } from './prefillCompanyDomainFromEmail';
import { prefillHubInterest } from './prefillHubInterest';
import { prefillSignupDataFromUrl } from './prefillSignupData';
export const PrefillingMiddleware = store => next => action => {
  const dispatchResult = next(action);

  if (action.type === AppActionTypes.AppStarted) {
    store.dispatch(prefillSignupDataFromUrl());
  }

  if (action.type === FlowActionTypes.Load) {
    store.dispatch(prefillHubInterest());
  }

  if (isDeveloperFlow()) {
    executeCallbackIfEmailSubmitted(store.getState(), action, email => {
      store.dispatch(prefillCompanyDomainFromEmail(email));
    });
  }

  return dispatchResult;
};